import { CheckCircle2, AlertTriangle, XCircle, Info } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useAlertStore } from '@/hooks/use-alert'

const variantIcons = {
  success: <CheckCircle2 className="h-6 w-6 text-emerald-500" />,
  error: <XCircle className="h-6 w-6 text-red-500" />,
  warning: <AlertTriangle className="h-6 w-6 text-amber-500" />,
  default: <Info className="h-6 w-6 text-blue-500" />,
}

const variantStyles = {
  success: 'text-emerald-600 dark:text-emerald-400',
  error: 'text-red-600 dark:text-red-400',
  warning: 'text-amber-600 dark:text-amber-400',
  default: 'text-blue-600 dark:text-blue-400',
}

export function GlobalAlertDialog() {
  const { isOpen, title, description, variant, onConfirm, confirmText, showCancel, hideAlert } =
    useAlertStore()

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm()
    }
    hideAlert()
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && hideAlert()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            {variantIcons[variant]}
            <AlertDialogTitle className={variantStyles[variant]}>{title}</AlertDialogTitle>
          </div>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          {showCancel && (
            <AlertDialogCancel onClick={hideAlert}>Cancelar</AlertDialogCancel>
          )}
          <AlertDialogAction onClick={handleConfirm}>
            {confirmText || 'OK'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
